import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=bd3c00a4&scoped=true"
import script from "./partnerList.vue?vue&type=script&lang=js"
export * from "./partnerList.vue?vue&type=script&lang=js"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=bd3c00a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c00a4",
  null
  
)

export default component.exports